export default __webpack_public_path__ + "static/media/ark.5295cc4a.png";